<template>
  <span v-if="brand" style="margin-right:2px">
    <img v-if="brand == 'visa'" :src="cardImage" :style="'height:60px; margin-bottom:-25px'" />
    <img v-else-if="brand == 'amex'" :src="cardImage" :style="'height:30px'" />
    <img
      v-else-if="brand == 'discover'"
      :src="cardImage"
      :style="'height:50px; margin-bottom:-20px'"
    />
    <img
      v-else-if="brand == 'mastercard'"
      :src="cardImage"
      :style="'height:50px; margin-bottom:-20px'"
    />
    <CreditCardIcon v-else size="30" class="hero-icon" :color="themeColor('primary')"></CreditCardIcon>
  </span>
</template>

<script>
import { 
  CreditCardIcon,
} from '@vue-hero-icons/outline'

export default {
  props: ["brand"],
  data() {
    return {
      cardImage: null
    };
  },
  components: {
    CreditCardIcon
  },
  methods: {},
  created() {
    if (this.brand == "visa")
      this.cardImage = this.assets() + "/cards/visa.png";
    else if (this.brand == "amex")
      this.cardImage = this.assets() + "/cards/amex.png";
    else if (this.brand == "discover")
      this.cardImage = this.assets() + "/cards/discover.png";
    else if (this.brand == "mastercard")
      this.cardImage = this.assets() + "/cards/mastercard.png";
  },
  computed: {}
};
</script>

<style scoped>
.st0 {
  clip-path: url(#XMLID_27_);
  fill: url(#SVGID_1_);
}
</style>
